import { Injectable } from '@angular/core';

/**
 * åèhttps://github.com/mixalistzikas/ngbox
 */
@Injectable()
export class NgBoxService {

    public id = 0;
    public current: any;
    public loading = false;
    public open = false;
    public images: any = [];

    constructor() { }

}
